import {Controller, useFormContext} from "react-hook-form";
import {Input, Space} from "antd";
import {
  FormField,
  FormFieldError,
  FormFieldHelperText,
} from "../../../../../../../design-system/form-field";
import {CreateKycBasicFormStepFormValues} from "../../schema-validation";

export function KycResidentialAddressFormField() {
  const {control} = useFormContext<CreateKycBasicFormStepFormValues>();

  return (
    <FormField
      id="residentialAddress"
      label="Residential address"
      renderInput={(id) => (
        <Controller
          control={control}
          name="address"
          render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
            <Space size={8} direction="vertical" style={{display: "flex"}}>
              <Space size={4} direction="vertical" style={{display: "flex"}}>
                <Input
                  id={id}
                  status={error?.message ? "error" : ""}
                  onChange={onChange}
                  onBlur={onBlur}
                  size="large"
                  value={value === null ? undefined : value}
                  placeholder="Street, State/Province, Country (e.g., 123 Main St, Texas, USA)"
                  ref={ref}
                />
                <FormFieldHelperText text="Please enter your full residential address" />
              </Space>
              <FormFieldError errorMessage={error?.message} />
            </Space>
          )}
        />
      )}
    />
  );
}
